<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>


<!-- Telegram button (fixed bottom-right) -->
<div class="telegram-button-container">
    <a href="https://t.me/nonghyupfinancecambodia" target="_blank" class="telegram-button">
      <img [src]="baseApiUrl + '/uploads/images/icons/telegram_chat_icon.png'" alt="Telegram Chat">
      Join Us
    </a>
</div>



